import { useEffect, useMemo, useState } from 'react';
import {
    Box,
    VStack,
    Text,
} from '@chakra-ui/react';
import DayPicker, { Modifiers } from 'react-day-picker';
import MomentLocaleUtils from 'react-day-picker/moment';
import { DayPickerContainer } from '../../common/DayPicker/DayPickerStyled';
import { DayPickerNavBar } from '../../common/DayPicker/DayPickerNavBar';
import { DayPickerDay } from '../../common/DayPicker/DayPickerDay';
import {
    getDisabledDaysBeforeToday,
    getInitialDateRangeHoverState,
    getModifiers,
} from '../../../services/Date/DateRangeService';
import { RangeModifier } from 'react-day-picker/types/Modifiers';
import 'react-day-picker/lib/style.css';
import { ModalView } from './ModalView';
import moment from 'moment';
import { DayPickerRootContainer } from '../../../styles/DayPickerStyled';
import { fetchObjectVacations } from '../../../services/ObjectVacations/ObjectVacationsService';
import { ObjectVacationsParams } from '../../../types/ParamsTypes';

export interface BookingCalendarReadOnlyProps {
    objectId: string;
    switchBookingCalendarModal: boolean;
    handleBookingCalendarModal: () => void;
}

export const BookingCalendarReadOnly = ({
    objectId,
    switchBookingCalendarModal,
    handleBookingCalendarModal,
}: BookingCalendarReadOnlyProps): JSX.Element => {
    const [initialMonth, setInitialMonth] = useState<Date | undefined>();
    const [calendarPreviewRange, setCalendarPreviewRange] = useState<number>(3);
    const [selectedDateRange, setSelectedDateRange] = useState<RangeModifier>(
        getInitialDateRangeHoverState(),
    );
    const [disabledDays, setDisabledDays] = useState<Partial<Modifiers>>();
    const [modifiers, setModifiers] = useState<Partial<Modifiers>>();

    useEffect(() => {
        const vacData = fetchObjectVacations({
            Object: objectId
        } as ObjectVacationsParams);
        vacData.then(x => {
            setDisabledDays(getDisabledDaysBeforeToday(disabledDays));
            var bookedUpDates;
            if (x.data.data.result.vacationsData) {
                bookedUpDates = x.data.data.result.vacationsData
                    .filter(vacation => {
                        return moment(vacation.toDate).isAfter(new Date());
                    })
                    .map(vacation => {
                        return { from: new Date(vacation.fromDate), to: new Date(vacation.toDate) };
                    });
                setModifiers(
                    getModifiers(
                        selectedDateRange,
                        bookedUpDates,
                        0,
                        [],
                        {
                            potentialArrivalDay:
                                !selectedDateRange || (!!selectedDateRange && !selectedDateRange.from),
                            potentialDepartureDay:
                                !selectedDateRange ||
                                (!!selectedDateRange && !!selectedDateRange.from && !selectedDateRange.to),
                        },
                    ),
                );
            }
        });
    },
        []
    );

    const dayPicker = useMemo(
        () => (
            <DayPickerRootContainer>
                <DayPickerContainer>
                    <DayPicker
                        month={initialMonth}
                        className={'BookingCalendarReadOnly'}
                        renderDay={(date, modifiers) => (
                            <DayPickerDay
                                date={date}
                                modifiers={modifiers}
                                selectedDateRange={selectedDateRange}
                                showTooltips={false}
                            />
                        )}
                        navbarElement={props => {
                            return (
                                <DayPickerNavBar
                                    {...props}
                                />
                            );
                        }}
                        modifiers={modifiers as any}
                        localeUtils={MomentLocaleUtils}
                        locale={'de'}
                        numberOfMonths={calendarPreviewRange}
                        disabledDays={disabledDays as any}
                    />
                </DayPickerContainer>
            </DayPickerRootContainer>
        ),
        [
            modifiers,
            calendarPreviewRange,
            disabledDays,
            selectedDateRange],
    );

    return (
        <Box
            pl={{ sm: 0, md: 4, lg: 4, xl: 4 }}
            pr={{ sm: 0, md: 4, lg: 4, xl: 4 }}
            pt={{ sm: 2, md: 4, lg: 4, xl: 4 }}
            pb={{ sm: 2, md: 4, lg: 4, xl: 4 }}
            borderRadius={{ sm: 0, md: 4, lg: 4, xl: 4 }}
            borderWidth={1}
            borderColor={'gray.300'}
            backgroundColor={'white'}
            w={'100%'}
            id={'detailsBookingCalendar'}>
            <VStack alignItems={'flex-start'}>
                <Text w={'100%'} textAlign={'center'} fontSize={'xl'} textStyle={'category.primary'}>
                    Belegungsplan
                </Text>
                {dayPicker}
            </VStack>
        </Box>
    );
};